import { withStyles } from '@material-ui/core';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import PlaybackControls from 'tm3-core/controls/video/playback-controls';
import styles from './styles';

@inject('videoStore')
@observer
class VideoScreen extends Component {
  render() {
    const {
      videoStore: { hasPartipants }
    } = this.props;

    return (
      <div id="video-elements" className={this.elementClass}>
        <div
          id="local-media"
          style={{
            transform: 'rotateY(180deg)'
          }}
        />
        <div id="remote-media" style={{ display: 'block', margin: 'auto', width: '100%' }}>
          {!hasPartipants && (
            <div
              style={{
                color: 'white',
                flex: '1 1 auto',
                fontSize: 20,
                width: '100%',
                textAlign: 'center'
              }}
            >
              You are the only one here.
            </div>
          )}
        </div>
        <PlaybackControls />
      </div>
    );
  }

  @computed
  get elementClass() {
    const {
      classes: { videoElements, fullScreen },
      videoStore: { isFullScreen }
    } = this.props;
    return isFullScreen ? `${fullScreen} ${videoElements}` : videoElements;
  }
}

export default withStyles(styles)(VideoScreen);
